import React, { memo } from 'react';
import Box from '@mui/material/Box';
import { PageViewProps } from './types';

function PageView(props: PageViewProps): React.ReactElement {
  /* Global & Local State */
  const {
    children,
    tipsTitle,
    header,
    side,
    headerHeight = 48,
    sx,
    headerSx,
    containerSx,
    tipsTitleSx,
    external
  } = props;

  /* Main */
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        ...sx
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: headerHeight ? `${headerHeight}px` : '',
          position: 'relative',
          zIndex: 15,
          ...headerSx
        }}
      >
        {header}
      </Box>
      <Box
        sx={{
          width: '100%',
          height: headerHeight ? `calc(100% - ${headerHeight}px)` : '100%',
          display: 'flex',
          ...containerSx
        }}
      >
        {side}
        <Box
          sx={{
            width: { xs: '100%', sm: '100%', md: 'calc(100% - 208px)' },
            height: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            flex: 1,
            position: 'relative'
          }}
        >
          <Box
            sx={{
              flex: '1 1',
              height: '100%',
              position: 'relative',
              overflowX: 'hidden',
              overflowY: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {tipsTitle && <Box sx={{ width: '100%', height: '36px', ...tipsTitleSx }}>{tipsTitle}</Box>}
            <Box sx={{ width: '100%', height: tipsTitle ? 'calc(100% - 36px)' : '100%', flexGrow: 1 }}>{children}</Box>
          </Box>
        </Box>
      </Box>
      {external}
    </Box>
  );
}

export default memo(PageView);
